<div *ngIf="attachment" class="text-center">

  <ng-container [ngSwitch]="attachment.displayType">
    <ng-container *ngSwitchCase="'EMBED'">

      <img *ngIf="attachment.fileType.indexOf('image') !== -1" [alt]="attachment.fileName"
           [src]="attachment.fileLink" class="img-responsive"/>

      <video *ngIf="attachment.fileType.indexOf('video') !== -1" [src]="attachment.fileLink"
             autoplay class="img-responsive" controls></video>

    </ng-container>

    <iframe *ngSwitchCase="'IFRAME'"
            [src]="url | safeElement : 'url'"
            [title]="attachment?.description" height="600px"
            width="100%"></iframe>
  </ng-container>

</div>
